"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOldStyleCompatibleWithBlockType = exports.getBlockType = void 0;
var GetDefaultBlockStyle_1 = __importDefault(require("@CommonFrontendBackend/StyleServiceV2/DefaultBlockStyles/GetDefaultBlockStyle"));
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var ConvertV0FactoryStyle_1 = __importDefault(require("./ConvertV0FactoryStyle"));
var getSize = require("@CommonFrontendBackend/StyleService/GetSize");
exports.default = (function (brandColorsWithThemeIndex) {
    var convertStyle = function (style) {
        if (style.version === 2) {
            return style;
        }
        else if (style.version === 1) {
            return __assign(__assign({ blockType: (0, exports.getBlockType)(style), name: style.name, preTcdcRef: style.className, css: style.css, blockWidth: getColumnWidth(style.columnWidth), blockSpacing: "medium", background: __assign({}, getColor(style.background || "white")) }, getSplashFields(style)), { h1: {
                    color: getColor(style.colors.h1.name),
                    size: {
                        themeRef: null,
                        abs: getSizeAsNumber(style.fontStyles, "h1"),
                    },
                    alignment: style.alignment.h1,
                }, h2: {
                    color: getColor(style.colors.h2.name),
                    size: {
                        themeRef: null,
                        abs: getSizeAsNumber(style.fontStyles, "h2"),
                    },
                    alignment: style.alignment.h2,
                }, p: {
                    color: getColor(style.colors.p.name),
                    size: {
                        themeRef: null,
                        abs: getSizeAsNumber(style.fontStyles, "p"),
                    },
                    alignment: style.alignment.p,
                } });
        }
        else if (style.isFactoryStyle) {
            return (0, ConvertV0FactoryStyle_1.default)(style, brandColorsWithThemeIndex);
        }
        else {
            return __assign(__assign({}, (0, GetDefaultBlockStyle_1.default)(style.blockType, brandColorsWithThemeIndex)), { blockType: (0, exports.getBlockType)(style), name: style.name, preTcdcRef: style.className, css: getCssFromV0(style.styleModel) });
        }
    };
    var getSplashFields = function (style) {
        if (style.blockTypes.includes("Splash")) {
            return {
                backgroundCard: {
                    on: style.backgroundCard !== "none",
                    color: __assign(__assign({}, getColor(style.backgroundCard)), { opacity: 1 }),
                },
                tintBlendMode: "normal",
                background: getTintColor(style.tint),
            };
        }
        else {
            return {};
        }
    };
    var getTintColor = function (tint) {
        if (tint === "none") {
            return {
                opacity: 0,
                abs: DefaultColors_1.DEFAULT_WHITE.value,
                themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex,
            };
        }
        else {
            return __assign(__assign({}, getColor(tint || "white")), { opacity: 0.3 });
        }
    };
    var getColor = function (oldColor) {
        switch (oldColor) {
            case "brand":
                return {
                    themeIndex: 0,
                    abs: (0, ColorUtils_1.getRgba)(brandColorsWithThemeIndex[0].value),
                };
            case "complementary":
                return {
                    themeIndex: 1,
                    abs: (0, ColorUtils_1.getRgba)(brandColorsWithThemeIndex[1].value),
                };
            case "slate":
                return {
                    themeIndex: null,
                    abs: "rgba(74, 74, 74, 1)",
                };
            case "white":
                return {
                    themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex,
                    abs: DefaultColors_1.DEFAULT_WHITE.value,
                };
            case "silver":
                return {
                    themeIndex: DefaultColors_1.DEFAULT_GREY10.themeIndex,
                    abs: DefaultColors_1.DEFAULT_GREY10.value,
                };
            case "none":
                return {
                    themeIndex: null,
                    abs: "transparent",
                };
        }
    };
    return convertStyle;
});
var getColumnWidth = function (columnWidth) {
    if (columnWidth === "regular") {
        return "small";
    }
    return columnWidth || "medium";
};
var getBlockType = function (oldStyle) {
    if (oldStyle.legacyBlockType) {
        return oldStyle.legacyBlockType;
    }
    if (oldStyle.blockTypes && oldStyle.blockTypes.length) {
        if (oldStyle.blockTypes.includes(commonTypes_1.BlockType.Splash)) {
            return commonTypes_1.BlockType.Splash;
        }
        else if (oldStyle.blockTypes.includes(commonTypes_1.BlockType.Accept)) {
            return commonTypes_1.BlockType.Accept;
        }
        else if (oldStyle.blockTypes.includes(commonTypes_1.BlockType.Quote)) {
            return commonTypes_1.BlockType.Quote;
        }
    }
    else if (oldStyle.blockType) {
        if ([commonTypes_1.BlockType.Splash, commonTypes_1.BlockType.Source].includes(oldStyle.blockType)) {
            return oldStyle.blockType;
        }
    }
    return commonTypes_1.BlockType.Text;
};
exports.getBlockType = getBlockType;
var isOldStyleCompatibleWithBlockType = function (oldStyle, blockType) {
    var styleType = (0, exports.getBlockType)(oldStyle);
    return styleType === blockType || (["Video", "Source"].includes(blockType) && styleType === "Text");
};
exports.isOldStyleCompatibleWithBlockType = isOldStyleCompatibleWithBlockType;
var getSizeAsNumber = function (fontStyles, element) {
    var size = getSize(fontStyles, element, "desktop");
    return parseInt(size.replace("px", ""), 10);
};
var getCssFromV0 = function (styleModel) {
    return styleModel.reduce(function (accumulator, current) {
        var rawStyles = current.rawStyles, element = current.element;
        if (!rawStyles.length) {
            return accumulator;
        }
        var currentCss;
        if (element.length) {
            currentCss = "".concat(element, " {\n  ").concat(rawStyles, "\n}");
        }
        else {
            currentCss = rawStyles;
        }
        if (accumulator) {
            return "".concat(accumulator, "\n").concat(currentCss);
        }
        else {
            return currentCss;
        }
    }, "");
};
